import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function BalerReplacementParts() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/service-department">Service Department</Link>
          <Link to="/baler-refurbishing-services">Baler Refurbishing Services</Link>
          <Link className="active" to="/baler-replacement-parts">Baler Replacement Parts</Link>
          <Link to="/baling-wire">Baling Wire</Link>
          <Link to="/contact/baling-wire">Baling Wire Quotation</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Parts &amp; Service</span>
          <h2>Baler Replacement Parts</h2>
          <div className="gold-note">Note: Replacement or spare wear parts, quick-lock and single loop baling wire, and factory or field repair services are available as needed. Expedited and special order parts can be shipped by contacting our parts department at (336) 723-4869 or (800) 225-3796 or by email at <a href="mailto:parts@baling.com">parts@baling.com</a>. C+M Technical Services can be contacted via our general number (336) 723-1838.</div>
          <div className="content-stack">
            <section className="content-block">
              <h3>Genuine Replacement Parts</h3>
              <div className="selection-media-row">
                <div className="selection-media-copy">
                  <div className="body-copy">When <strong>replacement parts</strong> are required, our <strong>Parts Department</strong> can provide most all components for your baling press.</div>
                  <ul className="service-list">
                    <li>Hydraulic system valves, pumps, filters, and pressure switches</li>
                    <li>New compression or door cylinders</li>
                    <li>Electrical parts including new PLC controllers, motor starters, disconnects, fuses, and push buttons</li>
                    <li>Banner material level photo sensors and SONAC sensors</li>
                    <li>C+M auto-tie system wear parts such as wire twisters, wire rollers, and guides</li>
                    <li>C+M standard and serrated shear blades</li>
                    <li>Material retention dogs or springs</li>
                    <li>Cylinder repacking kits</li>
                  </ul>
                </div>
                <img className="service-side-image" src="/img/thumbnails/BalerReplacementPartsPic1.jpg" alt="C+M serrated shear blade replacement part" />
              </div>
            </section>
            <section className="content-block">
              <div className="selection-media-row reverse">
                <div className="selection-media-copy">
                  <ul className="service-list">
                    <li>Cut-to-fit abrasive resistant steel plate for relining your baler floor or ram</li>
                    <li>Ram wear strips for upper, side, or bottom made from UHMW, nylon, or graphite impregnated materials</li>
                    <li>Most any other parts or baling system supplies</li>
                  </ul>
                  <div className="body-copy">C+M <strong>replacement parts</strong> are competitively priced and promptly shipped by our experienced parts department staff.</div>
                </div>
                <img className="service-side-image" src="/img/thumbnails/BalerReplacementPartsPic2.jpg" alt="Hydraulic valve replacement part" />
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/general-inquiry">Contact C+M <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default BalerReplacementParts;
